var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:_vm.signed ? _vm.color : ''},[_c('span',{staticClass:"text-no-wrap base-money",attrs:{"data-base-money-numeric-value":_vm.amount,"data-amount":_vm.fixed}},[_vm._v(_vm._s(_vm.formatted || _vm.$t('common.NA')))])])}
var staticRenderFns = []

export { render, staticRenderFns }